function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Tabs, message, Skeleton, Button, Typography, Space, Select, Drawer, Form, Modal, notification, DatePicker } from 'antd';
import { Table } from 'react-bootstrap';
import { PencilSquare, HourglassSplit, EyeFill, CheckCircleFill } from "react-bootstrap-icons";
import Common from "../components/includes/Common";
import Moment from "react-moment";
import SaveMedicalQuestions from "../components/forms/SaveMedicalQuestions";
import SaveDrugData from "../components/forms/SaveDrugData";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var Text = Typography.Text,
  Link = Typography.Link;
var Drug = function Drug() {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    compList = _useState4[0],
    setCompList = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    compOptions = _useState6[0],
    setCompOptions = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    companyId = _useState8[0],
    setCompanyId = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    company = _useState0[0],
    setCompany = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    customers = _useState10[0],
    setCustomers = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    currentCustomer = _useState12[0],
    setCurrentCustomer = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    dataChanged = _useState14[0],
    setDataChanged = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    showEditData = _useState16[0],
    setShowEditData = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showDisplayData = _useState18[0],
    setShowDisplayData = _useState18[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var handleCompanyChange = function handleCompanyChange(v) {
    setCompany(compList.filter(function (c) {
      return c.id == v;
    })[0]);
    setCompanyId(compList.filter(function (c) {
      return c.id == v;
    })[0].id);
  };
  var items = [{
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(HourglassSplit, {
        size: 24
      }), " CANDIDATS EN ATTENTE"]
    }),
    key: 1,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Table, {
        striped: true,
        bordered: true,
        hover: true,
        responsive: true,
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: "Date"
            }), /*#__PURE__*/_jsx("th", {
              children: "NOM"
            }), /*#__PURE__*/_jsx("th", {
              children: "POSTE"
            }), /*#__PURE__*/_jsx("th", {
              children: "CONTACT"
            }), /*#__PURE__*/_jsx("th", {
              children: "SOCIETE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NATIONALITE"
            }), /*#__PURE__*/_jsx("th", {
              children: "ACTION"
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: customers.filter(function (c) {
            return c.drug_test_id == null;
          }).map(function (c) {
            return /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: /*#__PURE__*/_jsx(Moment, {
                    date: c.created_at,
                    format: "DD/MM/YYYY"
                  })
                })
              }), /*#__PURE__*/_jsx("td", {
                children: c.name
              }), /*#__PURE__*/_jsx("td", {
                children: c.job
              }), /*#__PURE__*/_jsx("td", {
                children: c.mobile_first
              }), /*#__PURE__*/_jsx("td", {
                children: c.company.label
              }), /*#__PURE__*/_jsx("td", {
                children: c.nationality
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsxs(Button, {
                  type: "link",
                  onClick: function onClick() {
                    setCurrentCustomer(c);
                    setShowEditData(true);
                  },
                  children: [/*#__PURE__*/_jsx(PencilSquare, {
                    size: 22
                  }), " ", /*#__PURE__*/_jsx("b", {
                    children: " TRAITER"
                  })]
                })
              })]
            }, c.id);
          })
        })]
      }), isDataLoading == true && /*#__PURE__*/_jsx(Skeleton, {
        active: true
      })]
    })
  }, {
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(CheckCircleFill, {
        size: 24
      }), " CANDIDATS TRAITES"]
    }),
    key: 2,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Table, {
        striped: true,
        bordered: true,
        hover: true,
        responsive: true,
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: "Date"
            }), /*#__PURE__*/_jsx("th", {
              children: "NOM"
            }), /*#__PURE__*/_jsx("th", {
              children: "POSTE"
            }), /*#__PURE__*/_jsx("th", {
              children: "CONTACT"
            }), /*#__PURE__*/_jsx("th", {
              children: "SOCIETE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NATIONALITE"
            }), /*#__PURE__*/_jsx("th", {
              children: "ACTION"
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: customers.filter(function (c) {
            return c.drug_test_id != null;
          }).map(function (c) {
            return /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: /*#__PURE__*/_jsx(Moment, {
                    date: c.created_at,
                    format: "DD/MM/YYYY"
                  })
                })
              }), /*#__PURE__*/_jsx("td", {
                children: c.name
              }), /*#__PURE__*/_jsx("td", {
                children: c.job
              }), /*#__PURE__*/_jsx("td", {
                children: c.mobile_first
              }), /*#__PURE__*/_jsx("td", {
                children: c.company.label
              }), /*#__PURE__*/_jsx("td", {
                children: c.nationality
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsxs(Space, {
                  direction: "horizontal",
                  children: [/*#__PURE__*/_jsxs(Button, {
                    type: "link",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowEditData(true);
                    },
                    children: [/*#__PURE__*/_jsx(PencilSquare, {
                      size: 22
                    }), " ", /*#__PURE__*/_jsx("b", {
                      children: " MODIFIER"
                    })]
                  }), /*#__PURE__*/_jsxs(Button, {
                    type: "link",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowDisplayData(true);
                    },
                    children: [/*#__PURE__*/_jsx(EyeFill, {
                      size: 22
                    }), " ", /*#__PURE__*/_jsx("b", {
                      children: " VOIR"
                    })]
                  })]
                })
              })]
            }, c.id);
          })
        })]
      }), isDataLoading == true && /*#__PURE__*/_jsx(Skeleton, {
        active: true
      })]
    })
  }];
  var loadData = function loadData(cid) {
    setIsDataLoading(true);
    if (cid == null) return;
    axios.get("".concat(Common.baseApiUrl, "getdrugqueue/").concat(cid, "/").concat(Common.currentUser.id)).then(function (response) {
      setCustomers(response.data.customers);
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  };
  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + 'getcompanylist').then(function (response) {
      if (response.data.status == 200) {
        setCompOptions([]);
        response.data.companyList.forEach(function (c) {
          setCompOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: c.id,
              label: c.label
            }]);
          });
        });
        setCompList(response.data.companyList);
        setCompanyId(response.data.companyList[0].id);
        setCompany(response.data.companyList[0]);
        loadData(response.data.companyList[0].id);
        if (response.data.companyList.length > 0) form.setFieldsValue({
          comp: response.data.companyList[0].id
        });
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  useEffect(function () {
    loadData(companyId);
  }, [companyId, dataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: [/*#__PURE__*/_jsx(Text, {
            mark: true,
            children: /*#__PURE__*/_jsx("b", {
              children: "#TESTE D'ADDICTION"
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
        })
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 9,
          md: 9,
          children: [/*#__PURE__*/_jsx(Form, {
            form: form,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "comp",
              children: /*#__PURE__*/_jsx(Select, {
                options: compOptions,
                onChange: handleCompanyChange,
                style: {
                  width: "200px"
                }
              })
            })
          }), /*#__PURE__*/_jsx(Tabs, {
            items: items,
            animated: true,
            defaultActiveKey: 1
          })]
        })
      })]
    }), currentCustomer && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Modal, {
        open: showEditData,
        title: /*#__PURE__*/_jsx("b", {
          children: "ENTREZ LES DONNEES DU TESTE D'ADDICTION"
        }),
        width: 470,
        footer: null,
        onCancel: function onCancel() {
          setShowEditData(false);
        },
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(SaveDrugData, {
          candidat: currentCustomer,
          handler: function handler() {
            setDataChanged(true);
            setShowEditData(false);
            notification.success({
              message: "Ok!",
              description: "Les donnés ont été sauvegardées"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        open: showDisplayData,
        title: /*#__PURE__*/_jsx("b", {
          children: "DETAILS QUESTIONNAIRE"
        }),
        width: "80%",
        onClose: function onClose() {
          setShowDisplayData(false);
        },
        destroyOnClose: true
      })]
    })]
  });
};
export default Drug;